// @ts-check
/** @typedef {{exportTemplate: import('../state').ExportTemplateState}} RootState */
export * from './edit';
export * from './draft';
export * from './favourites';
export * from './metadata';

/** @param {RootState} state */
export const getSelectedTemplateId = state =>
  state.exportTemplate.selectedTemplateId;

/** @param {RootState} state */
export const getDropdownTemplates = state =>
  state.exportTemplate.dropdownTemplates;

/**
 * @param {RootState} state */
export const getSearchConfiguration = state =>
  state.exportTemplate.searchConfig;

/** @param {RootState} state */
export const getMutationCount = state =>
  state.exportTemplate.searchConfig.mutationCount;

/** @param {RootState} state */
export const getOneTimeExport = state => state.exportTemplate.oneTimeExport;
